import {enumType} from 'common/enumType';
import {enums} from 'types/enums';

const buildDay = (
   id: string,
   name: string,
   dayOfWeek: keyof typeof enums.DayOfWeek.enum | null,
   week: number
) => ({id, name, dayOfWeek, week});

export const DayOfMonth = enumType({
   ONE: buildDay('ONE', '1st', null, 0),
   TWO: buildDay('TWO', '2nd', null, 0),
   THREE: buildDay('THREE', '3rd', null, 0),
   FOUR: buildDay('FOUR', '4th', null, 0),
   FIVE: buildDay('FIVE', '5th', null, 0),
   SIX: buildDay('SIX', '6th', null, 0),
   SEVEN: buildDay('SEVEN', '7th', null, 0),
   EIGHT: buildDay('EIGHT', '8th', null, 0),
   NINE: buildDay('NINE', '9th', null, 0),
   TEN: buildDay('TEN', '10th', null, 0),
   ELEVEN: buildDay('ELEVEN', '11th', null, 0),
   TWELVE: buildDay('TWELVE', '12th', null, 0),
   THIRTEEN: buildDay('THIRTEEN', '13th', null, 0),
   FOURTEEN: buildDay('FOURTEEN', '14th', null, 0),
   FIFTEEN: buildDay('FIFTEEN', '15th', null, 0),
   SIXTEEN: buildDay('SIXTEEN', '16th', null, 0),
   SEVENTEEN: buildDay('SEVENTEEN', '17th', null, 0),
   EIGHTTEEN: buildDay('EIGHTTEEN', '18th', null, 0),
   NINETEEN: buildDay('NINETEEN', '19th', null, 0),
   TWENTY: buildDay('TWENTY', '20th', null, 0),
   TWENTY_ONE: buildDay('TWENTY_ONE', '21st', null, 0),
   TWENTY_TWO: buildDay('TWENTY_TWO', '22nd', null, 0),
   TWENTY_THREE: buildDay('TWENTY_THREE', '23rd', null, 0),
   TWENTY_FOUR: buildDay('TWENTY_FOUR', '24th', null, 0),
   TWENTY_FIVE: buildDay('TWENTY_FIVE', '25th', null, 0),
   TWENTY_SIX: buildDay('TWENTY_SIX', '26th', null, 0),
   TWENTY_SEVEN: buildDay('TWENTY_SEVEN', '27th', null, 0),
   TWENTY_EIGHT: buildDay('TWENTY_EIGHT', '28th', null, 0),
   TWENTY_NINE: buildDay('TWENTY_NINE', '29th', null, 0),
   THIRTY: buildDay('THIRTY', '30th', null, 0),
   THIRTY_ONE: buildDay('THIRTY_ONE', '31st', null, 0),
   LAST: buildDay('LAST', 'Last Day', null, 0),
   FIRST_SUNDAY: buildDay('FIRST_SUNDAY', '1st Sun', enums.DayOfWeek.enum.SUNDAY, 1),
   FIRST_MONDAY: buildDay('FIRST_MONDAY', '1st Mon', enums.DayOfWeek.enum.MONDAY, 1),
   FIRST_TUESDAY: buildDay('FIRST_TUESDAY', '1st Tue', enums.DayOfWeek.enum.TUESDAY, 1),
   FIRST_WEDNESDAY: buildDay('FIRST_WEDNESDAY', '1st Wed', enums.DayOfWeek.enum.WEDNESDAY, 1),
   FIRST_THURSDAY: buildDay('FIRST_THURSDAY', '1st Thu', enums.DayOfWeek.enum.THURSDAY, 1),
   FIRST_FRIDAY: buildDay('FIRST_FRIDAY', '1st Fri', enums.DayOfWeek.enum.FRIDAY, 1),
   FIRST_SATURDAY: buildDay('FIRST_SATURDAY', '1st Sat', enums.DayOfWeek.enum.SATURDAY, 1),
   SECOND_SUNDAY: buildDay('SECOND_SUNDAY', '2nd Sun', enums.DayOfWeek.enum.SUNDAY, 2),
   SECOND_MONDAY: buildDay('SECOND_MONDAY', '2nd Mon', enums.DayOfWeek.enum.MONDAY, 2),
   SECOND_TUESDAY: buildDay('SECOND_TUESDAY', '2nd Tue', enums.DayOfWeek.enum.TUESDAY, 2),
   SECOND_WEDNESDAY: buildDay('SECOND_WEDNESDAY', '2nd Wed', enums.DayOfWeek.enum.WEDNESDAY, 2),
   SECOND_THURSDAY: buildDay('SECOND_THURSDAY', '2nd Thu', enums.DayOfWeek.enum.THURSDAY, 2),
   SECOND_FRIDAY: buildDay('SECOND_FRIDAY', '2nd Fri', enums.DayOfWeek.enum.FRIDAY, 2),
   SECOND_SATURDAY: buildDay('SECOND_SATURDAY', '2nd Sat', enums.DayOfWeek.enum.SATURDAY, 2),
   THIRD_SUNDAY: buildDay('THIRD_SUNDAY', '3rd Sun', enums.DayOfWeek.enum.SUNDAY, 3),
   THIRD_MONDAY: buildDay('THIRD_MONDAY', '3rd Mon', enums.DayOfWeek.enum.MONDAY, 3),
   THIRD_TUESDAY: buildDay('THIRD_TUESDAY', '3rd Tue', enums.DayOfWeek.enum.TUESDAY, 3),
   THIRD_WEDNESDAY: buildDay('THIRD_WEDNESDAY', '3rd Wed', enums.DayOfWeek.enum.WEDNESDAY, 3),
   THIRD_THURSDAY: buildDay('THIRD_THURSDAY', '3rd Thu', enums.DayOfWeek.enum.THURSDAY, 3),
   THIRD_FRIDAY: buildDay('THIRD_FRIDAY', '3rd Fri', enums.DayOfWeek.enum.FRIDAY, 3),
   THIRD_SATURDAY: buildDay('THIRD_SATURDAY', '3rd Sat', enums.DayOfWeek.enum.SATURDAY, 3),
   FOURTH_SUNDAY: buildDay('FOURTH_SUNDAY', '4th Sun', enums.DayOfWeek.enum.SUNDAY, 4),
   FOURTH_MONDAY: buildDay('FOURTH_MONDAY', '4th Mon', enums.DayOfWeek.enum.MONDAY, 4),
   FOURTH_TUESDAY: buildDay('FOURTH_TUESDAY', '4th Tue', enums.DayOfWeek.enum.TUESDAY, 4),
   FOURTH_WEDNESDAY: buildDay('FOURTH_WEDNESDAY', '4th Wed', enums.DayOfWeek.enum.WEDNESDAY, 4),
   FOURTH_THURSDAY: buildDay('FOURTH_THURSDAY', '4th Thu', enums.DayOfWeek.enum.THURSDAY, 4),
   FOURTH_FRIDAY: buildDay('FOURTH_FRIDAY', '4th Fri', enums.DayOfWeek.enum.FRIDAY, 4),
   FOURTH_SATURDAY: buildDay('FOURTH_SATURDAY', '4th Sat', enums.DayOfWeek.enum.SATURDAY, 4),
   LAST_SUNDAY: buildDay('LAST_SUNDAY', 'Last Sun', enums.DayOfWeek.enum.SUNDAY, 5),
   LAST_MONDAY: buildDay('LAST_MONDAY', 'Last Mon', enums.DayOfWeek.enum.MONDAY, 5),
   LAST_TUESDAY: buildDay('LAST_TUESDAY', 'Last Tue', enums.DayOfWeek.enum.TUESDAY, 5),
   LAST_WEDNESDAY: buildDay('LAST_WEDNESDAY', 'Last Wed', enums.DayOfWeek.enum.WEDNESDAY, 5),
   LAST_THURSDAY: buildDay('LAST_THURSDAY', 'Last Thu', enums.DayOfWeek.enum.THURSDAY, 5),
   LAST_FRIDAY: buildDay('LAST_FRIDAY', 'Last Fri', enums.DayOfWeek.enum.FRIDAY, 5),
   LAST_SATURDAY: buildDay('LAST_SATURDAY', 'Last Sat', enums.DayOfWeek.enum.SATURDAY, 5),
} as const);
